import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';
import {_isFF} from '../../global/commonUtils';
import dhtmlxArray from './dhtmlxArray';
import {globalObj} from './dxGridComClass';

dhtmlXGridObject.prototype._pgn_template_compile = function (a) {
    a = a.replace(/\[([^\]]*)\]/g, function (e, c) {
        c = c.split(":");
        switch (c[0]) {
            case "from":
                return '"+(arguments[1]*1+(arguments[2]*1?1:0))+"';
            case "total":
                return '"+arguments[3]+"';
            case "to":
                return '"+arguments[2]+"';
            case "current":
            case "prev":
            case "next":
            case "prevpages":
            case "nextpages":
                return ("\"+this._pgn_link('" + c[0] + "','" + c[1] + "','" + c[2] + "')+\"");
            case "currentpages":
                return "\"+this._pgn_block('" + c[1] + "')+\"";
        }
    });
    return new Function('return "' + a + '";');
};
/**
 * 分页信息的label
 */
dhtmlXGridObject.prototype.i18n.paging = {
    results: "Results",
    records: "Records from ",
    to: " to ",
    page: "Page ",
    perpage: "rows per page",
    first: "To first Page",
    previous: "Previous Page",
    found: "Found records",
    next: "Next Page",
    last: "To last Page",
    of: " of ",
    notfound: "No Records Found"
};
/**
 * 使用工具栏模式配置分页
 * @param navButtons
 * @param navLabel
 * @param pageSelect
 * @param perPageSelect
 * //disables the page selector
 mygrid.setPagingWTMode(true,true,false,true);
 //disables the row-per-page selector
 mygrid.setPagingWTMode(true,true,true,false);
 //defines options of the row-per-page selector: 30 rows per page, 60 rows per page,etc.
 mygrid.setPagingWTMode(true,true,true,[30,60,90,120])
 */
dhtmlXGridObject.prototype.setPagingWTMode = function (navButtons, navLabel, pageSelect, perPageSelect) {
    this._WTDef = [navButtons, navLabel, pageSelect, perPageSelect];
};
dhtmlXGridObject.prototype._pgn_bricks = function (n, a, e) {
    // var h = (this.skin_name || "").split("_")[1];
    // var c = "";
    // if (h == "light" || h == "modern" || h == "skyblue") {
    //     c = "_" + h;
    // }
    // this.pagerElAr = new Array();
    // this.pagerElAr.pagerCont = document.createElement("DIV");
    // this.pagerElAr.pagerBord = document.createElement("DIV");
    // this.pagerElAr.pagerLine = document.createElement("DIV");
    // this.pagerElAr.pagerBox = document.createElement("DIV");
    // this.pagerElAr.pagerInfo = document.createElement("DIV");
    // this.pagerElAr.pagerInfoBox = document.createElement("DIV");
    // var m = this.globalBox || this.objBox;
    // this.pagerElAr.pagerCont.style.width = m.clientWidth + "px";
    // this.pagerElAr.pagerCont.style.overflow = "hidden";
    // this.pagerElAr.pagerCont.style.clear = "both";
    // this.pagerElAr.pagerBord.className = "dhx_pbox" + c;
    // this.pagerElAr.pagerLine.className = "dhx_pline" + c;
    // this.pagerElAr.pagerBox.style.clear = "both";
    // this.pagerElAr.pagerInfo.className = "dhx_pager_info" + c;
    // this.pagerElAr.pagerCont.appendChild(this.pagerElAr.pagerBord);
    // this.pagerElAr.pagerCont.appendChild(this.pagerElAr.pagerLine);
    // this.pagerElAr.pagerCont.appendChild(this.pagerElAr.pagerInfo);
    // this.pagerElAr.pagerLine.appendChild(this.pagerElAr.pagerBox);
    // this.pagerElAr.pagerInfo.appendChild(this.pagerElAr.pagerInfoBox);
    // this._pgn_parentObj.innerHTML = "";
    // this._pgn_parentObj.appendChild(this.pagerElAr.pagerCont);
    // if (this.rowsBuffer.length > 0) {
    //     var l = 20;
    //     var u = 22;
    //     var r:any=null;var o:any=null;
    //     if (n > this.pagesInGroup) {
    //         r= document.createElement("DIV");
    //         o = document.createElement("DIV");
    //         r.className = "dhx_page" + c;
    //         o.innerHTML = "&larr;";
    //         r.appendChild(o);
    //         this.pagerElAr.pagerBox.appendChild(r);
    //         let s = this;
    //         r.pgnum = (Math.ceil(n / this.pagesInGroup) - 1) * this.pagesInGroup;
    //         r.onclick = function () {
    //             s.changePage(this.pgnum);
    //         };
    //         l += u;
    //     }
    //     for (let g = 1; g <= this.pagesInGroup; g++) {
    //          r = document.createElement("DIV");
    //          o = document.createElement("DIV");
    //         r.className = "dhx_page" + c;
    //         var pageNumber =(Math.ceil(n / this.pagesInGroup) - 1) * this.pagesInGroup + g;
    //         if (pageNumber > Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize)) {
    //             break;
    //         }
    //         o.innerHTML = pageNumber;
    //         r.appendChild(o);
    //         if (n == pageNumber) {
    //             r.className += " dhx_page_active" + c;
    //             o.className = "dhx_page_active" + c;
    //         }
    //         else {
    //             let s = this;
    //             r.pgnum = pageNumber;
    //             r.onclick = function () {
    //                 s.changePage(this.pgnum);
    //             };
    //         }
    //         l += parseInt(u / 3+"") * pageNumber.toString().length + 15;
    //         o.style.width = parseInt(u / 3+"") * pageNumber.toString().length + 8 + "px";
    //         this.pagerElAr.pagerBox.appendChild(r);
    //     }
    //     if (Math.ceil(n / this.pagesInGroup) * this.pagesInGroup <
    //         Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize)) {
    //           r = document.createElement("DIV");
    //           o = document.createElement("DIV");
    //         r.className = "dhx_page" + c;
    //         o.innerHTML = "&rarr;";
    //         r.appendChild(o);
    //         this.pagerElAr.pagerBox.appendChild(r);
    //         let s = this;
    //         r.pgnum = Math.ceil(n / this.pagesInGroup) * this.pagesInGroup + 1;
    //         r.onclick = function () {
    //             s.changePage(this.pgnum);
    //         };
    //         l += u;
    //     }
    //     this.pagerElAr.pagerLine.style.width = l + "px";
    // }
    // if (this.rowsBuffer.length > 0 && this.showRecInfo) {
    //     this.pagerElAr.pagerInfoBox.innerHTML =
    //         this.i18n.paging.records +
    //         (a + 1) +
    //         this.i18n.paging.to +
    //         e +
    //         this.i18n.paging.of +
    //         this.rowsBuffer.length;
    // }
    // else {
    //     if (this.rowsBuffer.length == 0) {
    //         this.pagerElAr.pagerLine.parentNode.removeChild(this.pagerElAr.pagerLine);
    //         this.pagerElAr.pagerInfoBox.innerHTML = this.i18n.paging.notfound;
    //     }
    // }
    // this.pagerElAr.pagerBox.appendChild(document.createElement("SPAN")).innerHTML = "&nbsp;";
    // this.pagerElAr.pagerBord.appendChild(document.createElement("SPAN")).innerHTML = "&nbsp;";
    // this.pagerElAr.pagerCont.appendChild(document.createElement("SPAN")).innerHTML = "&nbsp;";
    // this.callEvent("onPaging", []);
};
dhtmlXGridObject.prototype._pgn_toolbar = function (l, m, c) {
    if (!this.aToolBar) {
        this.aToolBar = this._pgn_createToolBar();
    }
    var h = Math.ceil(this.rowsBuffer.length / this.rowsBufferOutSize);
    if (this._WTDef[0]) {
        this.aToolBar.enableItem("right");
        this.aToolBar.enableItem("rightabs");
        this.aToolBar.enableItem("left");
        this.aToolBar.enableItem("leftabs");
        if (this.currentPage >= h) {
            this.aToolBar.disableItem("right");
            this.aToolBar.disableItem("rightabs");
        }
        if (this.currentPage == 1) {
            this.aToolBar.disableItem("left");
            this.aToolBar.disableItem("leftabs");
        }
    }
    if (this._WTDef[2]) {
        var g = this;
        this.aToolBar.forEachListOption("pages", function (n) {
            g.aToolBar.removeListOption("pages", n);
        });
        var jsonObj = { dhx_skyblue: 4, dhx_web: 0, dhx_terrace: 14 };
        var a = jsonObj[this.aToolBar.conf.skin];
        for (var e = 0; e < h; e++) {
            this.aToolBar.addListOption("pages", "pages_" + (e + 1), NaN, "button", "<span style='padding: 0px " +
                a +
                "px 0px 0px;'>" +
                this.i18n.paging.page +
                (e + 1) +
                "</span>", "paging_page.gif");
        }
        this.aToolBar.setItemText("pages", this.i18n.paging.page + l);
    }
    if (this._WTDef[1]) {
        if (!this.getRowsNum()) {
            this.aToolBar.setItemText("results", this.i18n.paging.notfound);
        }
        else {
            this.aToolBar.setItemText("results", "<div style='width:100%; text-align:center'>" +
                this.i18n.paging.records +
                (m + 1) +
                this.i18n.paging.to +
                c +
                "</div>");
        }
    }
    if (this._WTDef[3]) {
        this.aToolBar.setItemText("perpagenum", this.rowsBufferOutSize.toString() + " " + this.i18n.paging.perpage);
    }
    this.callEvent("onPaging", []);
};
dhtmlXGridObject.prototype._pgn_createToolBar = function () {
    // this.aToolBar = new dhtmlXToolbarObject({
    //     parent: this._pgn_parentObj,
    //     skin: this._pgn_skin_tlb || this.skin_name,
    //     icons_path: this.imgURL
    // });
    // if (!this._WTDef) {
    //     this.setPagingWTMode(true, true, true, true);
    // }
    // var g = this;
    // this.aToolBar.attachEvent("onClick", function (h) {
    //     h = h.split("_");
    //     switch (h[0]) {
    //         case "leftabs":
    //             g.changePage(1);
    //             break;
    //         case "left":
    //             g.changePage(g.currentPage - 1);
    //             break;
    //         case "rightabs":
    //             g.changePage(99999);
    //             break;
    //         case "right":
    //             g.changePage(g.currentPage + 1);
    //             break;
    //         case "perpagenum":
    //             if (h[1] === this.undefined) {
    //                 return;
    //             }
    //             g.rowsBufferOutSize = parseInt(h[1]);
    //             g.changePage();
    //             g.aToolBar.setItemText("perpagenum", h[1] + " " + g.i18n.paging.perpage);
    //             break;
    //         case "pages":
    //             if (h[1] === this.undefined) {
    //                 return;
    //             }
    //             g.changePage(h[1]);
    //             g.aToolBar.setItemText("pages", g.i18n.paging.page + h[1]);
    //             break;
    //     }
    // });
    // if (this._WTDef[0]) {
    //     this.aToolBar.addButton("leftabs", NaN, null, "ar_left_abs.gif", "ar_left_abs_dis.gif");
    //     this.aToolBar.addButton("left", NaN, null, "ar_left.gif", "ar_left_dis.gif");
    // }
    // if (this._WTDef[1]) {
    //     this.aToolBar.addText("results", NaN, this.i18n.paging.results);
    //     this.aToolBar.setWidth("results", "150");
    //     this.aToolBar.disableItem("results");
    // }
    // if (this._WTDef[0]) {
    //     this.aToolBar.addButton("right", NaN, null, "ar_right.gif", "ar_right_dis.gif");
    //     this.aToolBar.addButton("rightabs", NaN, null, "ar_right_abs.gif", "ar_right_abs_dis.gif");
    // }
    // if (this._WTDef[2]) {
    //     if (this.aToolBar.conf.skin == "dhx_terrace") {
    //         this.aToolBar.addSeparator();
    //     }
    //     this.aToolBar.addButtonSelect("pages", NaN, "select page", [], "paging_pages.gif", null, false, true);
    // }
    // var a;
    // if ((a = this._WTDef[3])) {
    //     if (this.aToolBar.conf.skin == "dhx_terrace") {
    //         this.aToolBar.addSeparator();
    //     }
    //     this.aToolBar.addButtonSelect("perpagenum", NaN, "select size", [], "paging_rows.gif", null, false, true);
    //     if (typeof a != "object") {
    //         a = [5, 10, 15, 20, 25, 30];
    //     }
    //     var c = { dhx_skyblue: 4, dhx_web: 0, dhx_terrace: 18 }[this.aToolBar.conf.skin];
    //     for (var e = 0; e < a.length; e++) {
    //         this.aToolBar.addListOption("perpagenum", "perpagenum_" + a[e], NaN, "button", "<span style='padding: 0px " +
    //             c +
    //             "px 0px 0px;'>" +
    //             a[e] +
    //             " " +
    //             this.i18n.paging.perpage +
    //             "</span>", "paging_page.gif");
    //     }
    // }
    return this.aToolBar;
};
/**
 * 允许通过从外部文件（XML、JSON、JSARRAY、CSV）加载数据来发送POST请求。
 * @param url a
 * @param post c
 * @param call g
 * @param e
 */
dhtmlXGridObject.prototype.post = function (url, post, call, type) {
    this.callEvent("onXLS", [this]);
    if (arguments.length == 2 && typeof call != "function") {
        type = call;
        call = null;
    }
    type = type || "xml";
    if (!this.xmlFileUrl) {
        this.xmlFileUrl = url;
    }
    this._data_type = type;
    this.xmlLoader = this.doLoadDetails;
    var h = this;
    this.xmlLoader = function (l) {
        if (!h.callEvent) {
            return;
        }
        h["_process_" + type](l.xmlDoc);
        if (!h._contextCallTimer) {
            h.callEvent("onXLE", [h, 0, 0, l.xmlDoc]);
        }
        if (call) {
            call();
            call = null;
        }
    };
    dhx4.ajax.post(url, post || "", this.xmlLoader);
};
/**
 * 设置从指定单元格开始的指定长度的行跨度
 * @param rowID
 * @param colInd
 * @param len
 *
 * mygrid.setRowspan("row1",0,2);
 */
dhtmlXGridObject.prototype.setRowspan = function (rowID, colInd, len) {
    var u = this[this._bfs_cells ? "_bfs_cells" : "cells"](rowID, colInd).cell;
    var a = this.rowsAr[rowID];
    if (u.rowSpan && u.rowSpan != 1) {
        var l = a.nextSibling;
        for (var n = 1; n < u.rowSpan; n++) {
            var m = l.childNodes[l._childIndexes[u._cellIndex + 1]];
            var e = document.createElement("TD");
            e.innerHTML = "&nbsp;";
            e._cellIndex = u._cellIndex;
            e._clearCell = true;
            if (m) {
                m.parentNode.insertBefore(e, m);
            }
            else {
                l.parentNode.appendChild(e);
            }
            this._shiftIndexes(l, u._cellIndex, -1);
            l = l.nextSibling;
        }
    }
    u.rowSpan = len;
    if (!this._h2) {
        a = a.nextSibling || this.rowsCol[this.rowsCol._dhx_find(a) + 1];
    }
    else {
        a = this.rowsAr[this._h2.get[a.idd].parent.childs[this._h2.get[a.idd].index + 1].id];
    }
    var g = [];
    for (var n = 1; n < len; n++) {
        var o = null;
        if (this._fake && !this._realfake) {
            o = this._bfs_cells3(a, colInd).cell;
        }
        else {
            o = this.cells3(a, colInd).cell;
        }
        this._shiftIndexes(a, u._cellIndex, 1);
        if (o) {
            o.parentNode.removeChild(o);
        }
        g.push(a);
        if (!this._h2) {
            a = a.nextSibling || this.rowsCol[this.rowsCol._dhx_find(a) + 1];
        }
        else {
            a = this._h2.get[a.idd].parent.childs[this._h2.get[a.idd].index + 1];
            if (a) {
                a = this.rowsAr[a.id];
            }
        }
    }
    this.rowsAr[rowID]._rowSpan = this.rowsAr[rowID]._rowSpan || {};
    this.rowsAr[rowID]._rowSpan[colInd] = g;
    if (this._fake && !this._realfake && colInd < this._fake._cCount) {
        this._fake.setRowspan(rowID, colInd, len);
    }
};
dhtmlXGridObject.prototype._shiftIndexes = function (a, g, c) {
    if (!a._childIndexes) {
        a._childIndexes = new Array();
        for (var e = 0; e < a.childNodes.length; e++) {
            a._childIndexes[e] = e;
        }
    }
    for (var e_1 = 0; e_1 < a._childIndexes.length; e_1++) {
        if (e_1 > g) {
            a._childIndexes[e_1] = a._childIndexes[e_1] - c;
        }
    }
};
/**
 * 启动行合并
 */
dhtmlXGridObject.prototype.enableRowspan = function () {
    this._erspan = true;
    this.enableRowspan = function () { };
    this.attachEvent("onAfterSorting", function () {

        if (this._dload) {
            return;
        }

        for (var h = 1; h < this.obj.rows.length; h++) {

            if (this.obj.rows[h]._rowSpan) {

                var a = this.obj.rows[h];
                for (var l in a._rowSpan) {
                    var o = a;
                    var c = o._rowSpan[l];
                    for (var e = 0; e < c.length; e++) {
                        if (o.nextSibling) {
                            o.parentNode.insertBefore(c[e], o.nextSibling);
                        }
                        else {
                            o.parentNode.appendChild(c[e]);
                        }

                        if (this._fake) {

                            var g = this._fake.rowsAr[o.idd];

                            var m = this._fake.rowsAr[c[e].idd];
                            if (g.nextSibling) {
                                g.parentNode.insertBefore(m, g.nextSibling);
                            }
                            else {
                                g.parentNode.appendChild(m);
                            }

                            this._correctRowHeight(o.idd);
                        }
                        o = o.nextSibling;
                    }
                }
            }
        }

        var n = this.rowsCol.stablesort;

        this.rowsCol = new dhtmlxArray();

        this.rowsCol.stablesort = n;

        for (var h_1 = 1; h_1 < this.obj.rows.length; h_1++) {

            this.rowsCol.push(this.obj.rows[h_1]);
        }
    });
    this.attachEvent("onXLE", function (g, e, r, l) {

        for (var m = 0; m < this.rowsBuffer.length; m++) {

            var o = this.render_row(m);
            var n = o.childNodes;
            for (var h = 0; h < n.length; h++) {
                if (n[h]._attrs.rowspan) {

                    this.setRowspan(o.idd, n[h]._cellIndex, n[h]._attrs.rowspan);
                }
            }
        }
    });
};
dhx4.attachEvent("onGridCreated", function (a) {
    if (a._split_later) {
        a.splitAt(a._split_later);
    }
});
/**
 * 拆分网格
 */
dhtmlXGridObject.prototype.splitAt = function (m) {
    if (!this.obj.rows[0]) {
        return (this._split_later = m);
    }
    m = parseInt(m + "");
    var x = document.createElement("DIV");
    this.entBox.appendChild(x);
    var y = document.createElement("DIV");
    this.entBox.appendChild(y);
    for (var v = this.entBox.childNodes.length - 3; v >= 0; v--) {
        y.insertBefore(this.entBox.childNodes[v], y.firstChild);
    }
    this.entBox.style.position = "relative";
    this.globalBox = this.entBox;
    this.entBox = y;
    y.grid = this;
    x.style.cssText += "border:0px solid red !important;";
    y.style.cssText += "border:0px solid red !important;";
    y.style.top = "0px";
    y.style.position = "absolute";
    x.style.position = "absolute";
    x.style.top = "0px";
    x.style.left = "0px";
    x.style.zIndex = 11;
    y.style.height = x.style.height = this.globalBox.clientHeight;
    this._fake = new dhtmlXGridObject(x);
    this.globalBox = this._fake.globalBox = this.globalBox;
    this._fake._fake = this;
    this._fake._realfake = true;
    this._treeC = this.cellType._dhx_find("tree");
    this._fake.delim = this.delim;
    this._fake.customGroupFormat = this.customGroupFormat;
    this._fake.setImagesPath(this._imgURL);
    this._fake.iconURL = this.iconURL;
    this._fake._customSorts = this._customSorts;
    this._fake.noHeader = this.noHeader;
    this._fake._enbTts = this._enbTts;
    this._fake._drsclmW = this._drsclmW;
    this._fake._htkebl = this._htkebl;
    this._fake.clists = this.clists;
    this._fake.fldSort = new Array();
    this._fake.selMultiRows = this.selMultiRows;
    this._fake.multiLine = this.multiLine;
    this._fake._key_events = this._key_events;
    this._fake.smartTabOrder = this.smartTabOrder;
    this._fake._RaSeCol = this._RaSeCol;
    if (this.multiLine || this._erspan) {
        this.attachEvent("onCellChanged", this._correctRowHeight);
        this.attachEvent("onRowAdded", this._correctRowHeight);
        var c = function () {

            this.forEachRow(function (D) {

                this._correctRowHeight(D);
            });
        };
        this.attachEvent("onPageChanged", c);
        this.attachEvent("onXLE", c);
        this.attachEvent("onResizeEnd", c);
        if (!this._ads_count) {
            this.attachEvent("onAfterSorting", c);
        }
        if (this._srnd) {
            this.attachEvent("onFilterEnd", c);
        }
        this.attachEvent("onDistributedEnd", c);
    }
    this.attachEvent("onGridReconstructed", function () {

        this._fake.objBox.scrollTop = this.objBox.scrollTop;
    });
    this._fake.loadedKidsHash = this.loadedKidsHash;
    if (this._h2) {
        this._fake._h2 = this._h2;
    }
    this._fake._dInc = this._dInc;
    var n = [[], [], [], [], [], [], []];
    var s = [
        "hdrLabels",
        "initCellWidth",
        "cellType",
        "cellAlign",
        "cellVAlign",
        "fldSort",
        "columnColor"
    ];
    var h = [
        "setHeader",
        "setInitWidths",
        "setColTypes",
        "setColAlign",
        "setColVAlign",
        "setColSorting",
        "setColumnColor"
    ];
    this._fake.callEvent = function () {
        var D = true;
        this._fake._split_event = true;
        var E = arguments[0] == "onScroll";
        if (arguments[0] == "onGridReconstructed" || E) {
            this._fake.callEvent.apply(this, arguments);
        }
        if (!E) {
            D = this._fake.callEvent.apply(this._fake, arguments);
        }
        this._fake._split_event = false;
        return D;
    };
    if (this._elmn) {
        this._fake.enableLightMouseNavigation(true);
    }
    if (this._cssEven || this._cssUnEven) {
        this._fake.attachEvent("onGridReconstructed", function () {

            this._fixAlterCss();
        });
    }
    this._fake._cssSP = this._cssSP;
    this._fake.isEditable = this.isEditable;
    this._fake._edtc = this._edtc;
    if (this._sst) {
        this._fake.enableStableSorting(true);
    }
    this._fake._sclE = this._sclE;
    this._fake._dclE = this._dclE;
    this._fake._f2kE = this._f2kE;
    this._fake._maskArr = this._maskArr;
    this._fake._dtmask = this._dtmask;
    this._fake.combos = this.combos;
    var o = 0;
    var a = this.globalBox.offsetWidth;
    for (var v_1 = 0; v_1 < m; v_1++) {
        for (var u = 0; u < s.length; u++) {
            if (this[s[u]]) {
                n[u][v_1] = this[s[u]][v_1];
            }
            if (typeof n[u][v_1] == "string") {
                n[u][v_1] = n[u][v_1].replace(new RegExp("\\" + this.delim, "g"), "\\" + this.delim);
            }
        }
        if (_isFF) {
            n[1][v_1] = n[1][v_1] * 1;
        }
        if (this.cellWidthType == "%") {
            n[1][v_1] = Math.round((parseInt(this[s[1]][v_1]) * a) / 100);
            o += n[1][v_1];
        }
        else {
            o += parseInt(this[s[1]][v_1]);
        }
        this.setColumnHidden(v_1, true);
    }
    for (var u_1 = 0; u_1 < s.length; u_1++) {
        var r = n[u_1].join(this.delim);
        if (h[u_1] != "setHeader") {
            if (r != "") {
                this._fake[h[u_1]](r);
            }
        }
        else {
            this._fake[h[u_1]](r, null, this._hstyles);
        }
    }
    this._fake._strangeParams = this._strangeParams;
    this._fake._drsclmn = this._drsclmn;
    o = Math.min(this.globalBox.offsetWidth, o);
    y.style.left = o + "px";
    x.style.width = o + "px";
    y.style.width = Math.max(this.globalBox.offsetWidth - o, 0);
    if (this._ecspn) {
        this._fake._ecspn = true;
    }
    this._fake.init();
    if (this.dragAndDropOff) {
        this.dragger.addDragLanding(this._fake.entBox, this);
    }
    this._fake.objBox.style.overflow = "hidden";
    if (!dhtmlx.$customScroll) {
        this._fake.objBox.style.overflowX = "scroll";
    }
    else {
        this._fake.objBox._custom_scroll_mode = "";
    }
    this._fake._srdh = this._srdh || 20;
    this._fake._srnd = this._srnd;
    this._fake._cssEven = this._cssEven;
    this._fake._cssUnEven = this._cssUnEven;
    if (this.skin_name != this._fake.skin_name) {
        this._fake.setSkin(this.skin_name);
    }
    var A = this;
    function C(F) {
        var D = A.objBox;
        if (D.scrollHeight - D.offsetHeight > 2) {
            var E = F.wheelDelta / -40;
            if (F.wheelDelta === window.undefined) {
                E = F.detail;
            }
            D.scrollTop += E * 40;
            if (F.preventDefault) {
                F.preventDefault();
            }
        }
    }
    //注册鼠标滚动事件
    goingEvent(this._fake.objBox, "mousewheel", C);
    goingEvent(this._fake.objBox, "DOMMouseScroll", C);
    function g(E, D) {
        D.style.whiteSpace = "";
        var I = D.nextSibling;
        var F = D.parentNode;
        E.parentNode.insertBefore(D, E);
        if (!I) {
            F.appendChild(E);
        }
        else {
            F.insertBefore(E, I);
        }
        var H = E.style.display;
        E.style.display = D.style.display;
        D.style.display = H;
    }
    function w(L, T, M, E) {

        var F = new Array(m).join(this.delim);
        var N = [];
        if (L == 2) {
            for (var J = 0; J < m; J++) {
                var D = T[L - 1].cells[T[L - 1]._childIndexes ? T[L - 1]._childIndexes[J] : J];
                if (D.rowSpan && D.rowSpan > 1) {
                    N[D._cellIndex] = D.rowSpan - 1;
                    E[L - 1].cells[E[L - 1]._childIndexes ? E[L - 1]._childIndexes[J] : J].rowSpan = D.rowSpan;
                    D.rowSpan = 1;
                }
            }
        }
        for (L; L < T.length; L++) {

            this._fake.attachHeader(F, null, M);

            E = E || this._fake.ftr.childNodes[0].rows;
            var Q = m;
            var H = 0;
            for (var K = 0; K < Q; K++) {
                if (N[K]) {
                    N[K] = N[K] - 1;
                    if (dhx4.isIE || dhx4.isOpera) {
                        var I = document.createElement("TD");
                        if (_isFF) {
                            I.style.display = "none";
                        }
                        T[L].insertBefore(I, T[L].cells[0]);
                    }
                    H++;
                    continue;
                }
                var P = E[L].cells[K - H];
                var O = T[L].cells[K - (dhx4.isIE ? 0 : H)];
                var S = O.rowSpan;
                g(P, O);
                if (S > 1) {
                    N[K] = S - 1;
                    O.rowSpan = S;
                }
                if (E[L].cells[K].colSpan > 1) {
                    T[L].cells[K].colSpan = E[L].cells[K].colSpan;
                    Q -= E[L].cells[K].colSpan - 1;
                    for (var J_1 = 1; J_1 < E[L].cells[K].colSpan; J_1++) {
                        E[L].removeChild(E[L].cells[K + 1]);
                    }
                }
            }
        }
    }
    if (this.hdr.rows.length > 2) {
        w.call(this, 2, this.hdr.rows, "_aHead", this._fake.hdr.rows);
    }
    if (this.ftr) {

        w.call(this, 1, this.ftr.childNodes[0].rows, "_aFoot");
        this._fake.ftr.parentNode.style.bottom = (_isFF ? 2 : 1) + "px";
    }
    if (this.saveSizeToCookie) {
        this.saveSizeToCookie = function (E, D) {
            if (this._realfake) {
                return this._fake.saveSizeToCookie.apply(this._fake, arguments);
            }
            if (!E) {
                E = this.entBox.id;
            }
            var H = new Array();
            var I = "cellWidthPX";
            for (var F = 0; F < this[I].length; F++) {
                if (F < m) {
                    H[F] = this._fake[I][F];
                }
                else {
                    H[F] = this[I][F];
                }
            }
            H = H.join(",");
            this.setCookie(E, D, 0, H);
            H = (this.initCellWidth || new Array()).join(",");
            this.setCookie(E, D, 1, H);
            return true;
        };
        this.loadSizeFromCookie = function (D) {
            if (!D) {
                D = this.entBox.id;
            }
            var I = this._getCookie(D, 1);
            if (!I) {
                return;
            }
            this.initCellWidth = I.split(",");
            I = this._getCookie(D, 0);
            var J = "cellWidthPX";
            this.cellWidthType = "px";
            var F = 0;
            if (I && I.length) {
                I = I.split(",");
                for (var E = 0; E < I.length; E++) {
                    if (E < m) {
                        this._fake[J][E] = I[E];
                        F += I[E] * 1;
                    }
                    else {
                        this[J][E] = I[E];
                    }
                }
            }
            this._fake.entBox.style.width = F + "px";
            this._fake.objBox.style.width = F + "px";
            var H = this.globalBox.childNodes[1];
            H.style.left = F - (_isFF ? 0 : 0) + "px";
            if (this.ftr) {
                this.ftr.style.left = F - (_isFF ? 0 : 0) + "px";
            }
            H.style.width = this.globalBox.offsetWidth - F + "px";
            this.setSizes();
            return true;
        };
        this._fake.onRSE = this.onRSE;
    }
    this.setCellTextStyleA = this.setCellTextStyle;
    this.setCellTextStyle = function (E, F, D) {
        if (F < m) {
            this._fake.setCellTextStyle(E, F, D);
        }
        this.setCellTextStyleA(E, F, D);
    };
    this.setRowTextBoldA = this.setRowTextBold;
    this.setRowTextBold = function (D) {
        this.setRowTextBoldA(D);
        this._fake.setRowTextBold(D);
    };
    this.setRowColorA = this.setRowColor;
    this.setRowColor = function (E, D) {
        this.setRowColorA(E, D);
        this._fake.setRowColor(E, D);
    };
    this.setRowHiddenA = this.setRowHidden;
    this.setRowHidden = function (E, D) {
        this.setRowHiddenA(E, D);
        this._fake.setRowHidden(E, D);
    };
    this.setRowTextNormalA = this.setRowTextNormal;
    this.setRowTextNormal = function (D) {
        this.setRowTextNormalA(D);
        this._fake.setRowTextNormal(D);
    };
    this.getChangedRows = function (F) {
        var D = new Array();
        function E(I) {
            for (var H = 0; H < I.childNodes.length; H++) {
                if (I.childNodes[H].wasChanged) {
                    return (D[D.length] = I.idd);
                }
            }
        }
        this.forEachRow(function (J) {

            var I = this.rowsAr[J];

            var H = this._fake.rowsAr[J];
            if (I.tagName != "TR" || !H || H.tagName != "TR") {
                return;
            }
            if (F && I._added) {
                D[D.length] = I.idd;
            }
            else {
                if (!E(I)) {
                    E(H);
                }
            }
        });
        return D.join(this.delim);
    };
    this.setRowTextStyleA = this.setRowTextStyle;
    this.setRowTextStyle = function (E, D) {
        this.setRowTextStyleA(E, D);
        if (this._fake.rowsAr[E]) {
            this._fake.setRowTextStyle(E, D);
        }
    };
    this.lockRowA = this.lockRow;
    this.lockRow = function (E, D) {
        this.lockRowA(E, D);
        this._fake.lockRow(E, D);
    };
    this.getColWidth = function (D) {
        if (D < m) {
            return parseInt(this._fake.cellWidthPX[D]);
        }
        else {
            return parseInt(this.cellWidthPX[D]);
        }
    };
    this.getColumnLabel = function (D) {
        return this._fake.getColumnLabel.apply(D < m ? this._fake : this, arguments);
    };
    this.setColWidthA = this._fake.setColWidthA = this.setColWidth;
    this.setColWidth = function (D, E) {
        D = D * 1;
        if (D < m) {
            this._fake.setColWidthA(D, E);
        }
        else {
            this.setColWidthA(D, E);
        }
        if (D + 1 <= m) {
            this._fake._correctSplit(Math.min(this._fake.objBox.offsetWidth, this._fake.obj.offsetWidth));
        }
    };
    this.adjustColumnSizeA = this.adjustColumnSize;
    this.setColumnLabelA = this.setColumnLabel;
    this.setColumnLabel = function (E, D, I, H) {
        var F = this;
        if (E < m) {
            F = this._fake;
        }
        return this.setColumnLabelA.apply(F, [E, D, I, H]);
    };
    this.adjustColumnSize = function (D, E) {
        if (D < m) {
            if (dhx4.isIE) {
                this._fake.obj.style.tableLayout = "";
            }
            this._fake.adjustColumnSize(D, E);
            if (dhx4.isIE) {
                this._fake.obj.style.tableLayout = "fixed";
            }
            this._fake._correctSplit();
        }
        else {
            return this.adjustColumnSizeA(D, E);
        }
    };
    var e = "cells";
    this._bfs_cells = this[e];
    this[e] = function () {
        if (arguments[1] < m) {
            return this._fake.cells.apply(this._fake, arguments);
        }
        else {
            return this._bfs_cells.apply(this, arguments);
        }
    };
    this._bfs_isColumnHidden = this.isColumnHidden;
    this.isColumnHidden = function () {
        if (parseInt(arguments[0]) < m) {
            return this._fake.isColumnHidden.apply(this._fake, arguments);
        }
        else {
            return this._bfs_isColumnHidden.apply(this, arguments);
        }
    };
    this._bfs_setColumnHidden = this.setColumnHidden;
    this.setColumnHidden = function () {
        if (parseInt(arguments[0]) < m) {
            this._fake.setColumnHidden.apply(this._fake, arguments);
            return this._fake._correctSplit();
        }
        else {
            return this._bfs_setColumnHidden.apply(this, arguments);
        }
    };
    e = "cells2";
    this._bfs_cells2 = this[e];
    this[e] = function () {
        if (arguments[1] < m) {
            return this._fake.cells2.apply(this._fake, arguments);
        }
        else {
            return this._bfs_cells2.apply(this, arguments);
        }
    };
    e = "cells3";
    this._bfs_cells3 = this[e];
    this[e] = function (E, D) {
        if (arguments[1] < m && this._fake.rowsAr[arguments[0].idd]) {
            if (this._fake.rowsAr[E.idd] &&
                this._fake.rowsAr[E.idd].childNodes.length == 0) {
                return this._bfs_cells3.apply(this, arguments);
            }
            arguments[0] = arguments[0].idd;
            return this._fake.cells.apply(this._fake, arguments);
        }
        else {
            return this._bfs_cells3.apply(this, arguments);
        }
    };
    e = "changeRowId";
    this._bfs_changeRowId = this[e];
    this[e] = function () {
        this._bfs_changeRowId.apply(this, arguments);
        if (this._fake.rowsAr[arguments[0]]) {
            this._fake.changeRowId.apply(this._fake, arguments);
        }
    };
    this._fake.getRowById = function (F) {
        var E = this.rowsAr[F];
        if (!E && this._fake.rowsAr[F]) {
            E = this._fake.getRowById(F);
        }
        if (E) {
            if (E.tagName != "TR") {
                for (var D = 0; D < this.rowsBuffer.length; D++) {
                    if (this.rowsBuffer[D] && this.rowsBuffer[D].idd == F) {
                        return this.render_row(D);
                    }
                }
                if (this._h2) {
                    return this.render_row(null, E.idd);
                }
            }
            return E;
        }
        return null;
    };
    if (this.collapseKids) {
        this._fake._bfs_collapseKids = this.collapseKids;
        this._fake.collapseKids = function () {
            return this._fake.collapseKids.apply(this._fake, [
                this._fake.rowsAr[arguments[0].idd]
            ]);
        };
        this["_bfs_collapseKids"] = this.collapseKids;
        this["collapseKids"] = function () {
            var D = this["_bfs_collapseKids"].apply(this, arguments);
            this._fake._h2syncModel();
            if (!this._cssSP) {
                this._fake._fixAlterCss();
            }
        };
        this._fake._bfs_expandKids = this.expandKids;
        this._fake.expandKids = function () {
            this._fake.expandKids.apply(this._fake, [
                this._fake.rowsAr[arguments[0].idd]
            ]);
            if (!this._cssSP) {
                this._fake._fixAlterCss();
            }
        };
        this["_bfs_expandAll"] = this.expandAll;
        this["expandAll"] = function () {
            this._bfs_expandAll();
            this._fake._h2syncModel();
            if (!this._cssSP) {
                this._fake._fixAlterCss();
            }
        };
        this["_bfs_collapseAll"] = this.collapseAll;
        this["collapseAll"] = function () {
            this._bfs_collapseAll();
            this._fake._h2syncModel();
            if (!this._cssSP) {
                this._fake._fixAlterCss();
            }
        };
        this["_bfs_expandKids"] = this.expandKids;
        this["expandKids"] = function () {
            var D = this["_bfs_expandKids"].apply(this, arguments);
            this._fake._h2syncModel();
            if (!this._cssSP) {
                this._fake._fixAlterCss();
            }
        };
        this._fake._h2syncModel = function () {
            if (this._fake.pagingOn) {
                this._fake._renderSort();
            }
            else {
                this._renderSort();
            }
        };
        this._updateTGRState = function (D) {
            return this._fake._updateTGRState(D);
        };
    }
    if (this._elmnh) {
        this._setRowHoverA = this._fake._setRowHoverA = this._setRowHover;
        this._unsetRowHoverA = this._fake._unsetRowHoverA = this._unsetRowHover;
        this._setRowHover = this._fake._setRowHover = function () {
            var D = this.grid;
            D._setRowHoverA.apply(this, arguments);
            var E = dhx4.isIE ? event.srcElement : arguments[0].target;
            E = D._fake.rowsAr[D.getFirstParentOfType(E, "TD").parentNode.idd];
            if (E) {
                D._fake._setRowHoverA.apply(D._fake.obj, [
                    { target: E.childNodes[0] },
                    arguments[1]
                ]);
            }
        };
        var D = null;
        this._unsetRowHover = this._fake._unsetRowHover = function () {
            if (arguments[1]) {
                D = this;
            }
            else {
                D = this.grid;
            }
            D._unsetRowHoverA.apply(this, arguments);
            D._fake._unsetRowHoverA.apply(D._fake.obj, arguments);
        };
        this._fake.enableRowsHover(true, this._hvrCss);
        this.enableRowsHover(false);
        this.enableRowsHover(true, this._fake._hvrCss);
    }
    this._updateTGRState = function (D) {
        if (!D.update || D.id == 0) {
            return;
        }
        if (this.rowsAr[D.id].imgTag) {
            this.rowsAr[D.id].imgTag.src = this.iconTree + D.state + ".gif";
        }
        if (this._fake.rowsAr[D.id] && this._fake.rowsAr[D.id].imgTag) {
            this._fake.rowsAr[D.id].imgTag.src = this.iconTree + D.state + ".gif";
        }
        D.update = false;
    };
    this.copy_row = function (I) {
        var D = I.cloneNode(true);
        D._skipInsert = I._skipInsert;
        var J = m;
        D._attrs = {};
        D._css = I._css;
        if (this._ecspn) {
            J = 0;
            for (var H = 0; J < D.childNodes.length && H < m; H += D.childNodes[J].colSpan || 1) {
                J++;
            }
        }
        while (D.childNodes.length > J) {
            D.removeChild(D.childNodes[D.childNodes.length - 1]);
        }
        var F = J;
        for (var H_1 = 0; H_1 < F; H_1++) {
            if (this.dragAndDropOff) {
                this.dragger.addDraggableItem(D.childNodes[H_1], this);
            }
            D.childNodes[H_1].style.display = this._fake._hrrar
                ? this._fake._hrrar[H_1]
                    ? "none"
                    : ""
                : "";
            D.childNodes[H_1]._cellIndex = H_1;
            D.childNodes[H_1].combo_value = arguments[0].childNodes[H_1].combo_value;
            D.childNodes[H_1]._clearCell = arguments[0].childNodes[H_1]._clearCell;
            D.childNodes[H_1]._cellType = arguments[0].childNodes[H_1]._cellType;
            D.childNodes[H_1]._brval = arguments[0].childNodes[H_1]._brval;
            D.childNodes[H_1].val = arguments[0].childNodes[H_1].val;
            D.childNodes[H_1]._combo = arguments[0].childNodes[H_1]._combo;
            D.childNodes[H_1]._attrs = arguments[0].childNodes[H_1]._attrs;
            D.childNodes[H_1].chstate = arguments[0].childNodes[H_1].chstate;
            if (I._attrs.style) {
                D.childNodes[H_1].style.cssText =
                    I._attrs.style + ";" + D.childNodes[H_1].style.cssText;
            }
            if (D.childNodes[H_1].colSpan > 1) {
                D._childIndexes = arguments[0]._childIndexes;
            }
        }
        if (this._h2 && this._treeC < m) {
            var E = this._h2.get[arguments[0].idd];
            D.imgTag = D.childNodes[this._treeC].childNodes[0].childNodes[E.level];
            D.valTag =
                D.childNodes[this._treeC].childNodes[0].childNodes[E.level + 2];
        }
        D.idd = I.idd;
        D.grid = this._fake;
        return D;
    };
    e = "_insertRowAt";
    this._bfs_insertRowAt = this[e];
    this[e] = function () {
        var E = this["_bfs_insertRowAt"].apply(this, arguments);
        arguments[0] = this.copy_row(arguments[0]);
        var D = this._fake._insertRowAt.apply(this._fake, arguments);
        if (E._fhd) {
            D.parentNode.removeChild(D);
            this._fake.rowsCol._dhx_removeAt(this._fake.rowsCol._dhx_find(D));
            E._fhd = false;
        }
        return E;
    };
    this._bfs_setSizes = this.setSizes;
    this.setSizes = function () {
        if (this._notresize) {
            return;
        }
        this._bfs_setSizes(this, arguments);
        this.sync_headers();
        if (this.sync_scroll() && this._ahgr) {
            this.setSizes();
        }
        var D = this.dontSetSizes
            ? this.entBox.offsetHeight + "px"
            : this.entBox.style.height;
        this._fake.entBox.style.height = D;
        this._fake.objBox.style.height = this.objBox.style.height;
        this._fake.hdrBox.style.height = this.hdrBox.style.height;
        this._fake.objBox.scrollTop = this.objBox.scrollTop;
        this._fake.setColumnSizes(this._fake.entBox.clientWidth);
        this.globalBox.style.width =
            parseInt(this.entBox.style.width) +
                parseInt(this._fake.entBox.style.width);
        if (!this.dontSetSizes) {
            this.globalBox.style.height = D;
        }
    };
    this.sync_scroll = this._fake.sync_scroll = function (E) {
        var D = this.objBox.style.overflowX;
        if (this.obj.offsetWidth <= this.objBox.offsetWidth) {
            if (!E) {
                return this._fake.sync_scroll(true);
            }
            this.objBox.style.overflowX = "hidden";
            this._fake.objBox.style.overflowX = "hidden";
        }
        else {
            if (!dhtmlx.$customScroll) {
                this.objBox.style.overflowX = "scroll";
                this._fake.objBox.style.overflowX = "scroll";
            }
        }
        return D != this.objBox.style.overflowX;
    };
    this.sync_headers = this._fake.sync_headers = function () {
        if (this.noHeader ||
            this._fake.hdr.scrollHeight == this.hdr.offsetHeight ||
            this.noHeaderResize) {
            return;
        }
        for (var E = 1; E < this.hdr.rows.length; E++) {
            var I = m;
            while (!this.hdr.rows[E].childNodes[I]) {
                I--;
            }
            var D = Math.min(this.hdr.rows[E].childNodes[I].scrollHeight + 2, this.hdr.rows[E].scrollHeight);
            var H = this._fake.hdr.rows[E].scrollHeight;
            if (D != H) {
                this._fake.hdr.rows[E].style.height = this.hdr.rows[E].style.height =
                    Math.max(D, H) + "px";
            }
            if (window._KHTMLrv) {
                var F = 0;
                while (this._fake._hrrar[F]) {
                    F++;
                }
                this._fake.hdr.rows[E].childNodes[F].style.height = this.hdr.rows[E].childNodes[I].style.height = Math.max(D, H) + "px";
            }
        }
        this._fake.sync_headers;
    };
    this._fake._bfs_setSizes = this._fake.setSizes;
    this._fake.setSizes = function () {
        if (this._fake._notresize) {
            return;
        }
        this._fake.setSizes();
    };
    e = "_doOnScroll";
    this._bfs__doOnScroll = this[e];
    this[e] = function () {
        this._bfs__doOnScroll.apply(this, arguments);
        this._fake.objBox.scrollTop = this.objBox.scrollTop;
        this._fake._doOnScroll.apply(this._fake, arguments);
    };
    e = "selectAll";
    this._bfs__selectAll = this[e];
    this[e] = function () {
        this._bfs__selectAll.apply(this, arguments);
        this._bfs__selectAll.apply(this._fake, arguments);
    };
    e = "doClick";
    this._bfs_doClick = this[e];
    this[e] = function () {
        this["_bfs_doClick"].apply(this, arguments);
        if (arguments[0].tagName == "TD") {
            var D = arguments[0]._cellIndex >= m;
            if (!arguments[0].parentNode.idd) {
                return;
            }
            if (!D) {
                arguments[0].className = arguments[0].className.replace(/cellselected/g, "");
            }
            if (!this._fake.rowsAr[arguments[0].parentNode.idd]) {
                this._fake.render_row(this.getRowIndex(arguments[0].parentNode.idd));
            }
            arguments[0] = this._fake.cells(arguments[0].parentNode.idd, D ? 0 : arguments[0]._cellIndex).cell;
            if (D) {
                this._fake.cell = null;
            }
            this._fake._bfs_doClick.apply(this._fake, arguments);
            if (D) {
                this._fake.cell = this.cell;
            }
            else {
                this.cell = this._fake.cell;
            }
            if (this._fake.onRowSelectTime) {
                clearTimeout(this._fake.onRowSelectTime);
            }
            if (D) {
                arguments[0].className = arguments[0].className.replace(/cellselected/g, "");
                globalObj.globalActiveDHTMLGridObject = this;
                this._fake.cell = this.cell;
            }
            else {
                this.objBox.scrollTop = this._fake.objBox.scrollTop;
            }
        }
    };
    this._fake._bfs_doClick = this._fake[e];
    this._fake[e] = function () {
        this["_bfs_doClick"].apply(this, arguments);
        if (arguments[0].tagName == "TD") {
            var D = arguments[0]._cellIndex < m;
            if (!arguments[0].parentNode.idd) {
                return;
            }
            arguments[0] = this._fake._bfs_cells(arguments[0].parentNode.idd, D ? m : arguments[0]._cellIndex).cell;
            this._fake.cell = null;
            this._fake._bfs_doClick.apply(this._fake, arguments);
            this._fake.cell = this.cell;
            if (this._fake.onRowSelectTime) {
                clearTimeout(this._fake.onRowSelectTime);
            }
            if (D) {
                arguments[0].className = arguments[0].className.replace(/cellselected/g, "");
                globalObj.globalActiveDHTMLGridObject = this;
                this._fake.cell = this.cell;
                this._fake.objBox.scrollTop = this.objBox.scrollTop;
            }
        }
    };
    this.clearSelectionA = this.clearSelection;
    this.clearSelection = function (D) {
        if (D) {
            this._fake.clearSelection();
        }
        this.clearSelectionA();
    };
    this.moveRowUpA = this.moveRowUp;
    this.moveRowUp = function (D) {
        if (!this._h2) {
            this._fake.moveRowUp(D);
        }
        this.moveRowUpA(D);
        if (this._h2) {
            this._fake._h2syncModel();
        }
    };
    this.moveRowDownA = this.moveRowDown;
    this.moveRowDown = function (D) {
        if (!this._h2) {
            this._fake.moveRowDown(D);
        }
        this.moveRowDownA(D);
        if (this._h2) {
            this._fake._h2syncModel();
        }
    };
    this._fake.getUserData = function () {
        return this._fake.getUserData.apply(this._fake, arguments);
    };
    this._fake.setUserData = function () {
        return this._fake.setUserData.apply(this._fake, arguments);
    };
    this.getSortingStateA = this.getSortingState;
    this.getSortingState = function () {
        var D = this.getSortingStateA();
        if (D.length != 0) {
            return D;
        }
        return this._fake.getSortingState();
    };
    this.setSortImgStateA = this._fake.setSortImgStateA = this.setSortImgState;
    this.setSortImgState = function (E, D, H, F) {
        this.setSortImgStateA(E, D, H, F);
        if (D * 1 < m) {
            this._fake.setSortImgStateA(E, D, H, F);
            this.setSortImgStateA(false);
        }
        else {
            this._fake.setSortImgStateA(false);
        }
    };
    this._fake.doColResizeA = this._fake.doColResize;
    this._fake.doColResize = function (I, H, F, D, K) {
        var E = -1;
        var J = 0;
        if (arguments[1]._cellIndex == m - 1) {
            E = this._initalSplR + (I.clientX - D);
            if (!this._initalSplF) {
                this._initalSplF =
                    arguments[3] + this.objBox.scrollWidth - this.objBox.offsetWidth;
            }
            if (this.objBox.scrollWidth == this.objBox.offsetWidth &&
                (this._fake.alter_split_resize || I.clientX - D > 0)) {
                arguments[3] = this._initalSplF || arguments[3];
                J = this.doColResizeA.apply(this, arguments);
            }
            else {
                J = this.doColResizeA.apply(this, arguments);
            }
        }
        else {
            if (this.obj.offsetWidth < this.entBox.offsetWidth) {
                E = this.obj.offsetWidth;
            }
            J = this.doColResizeA.apply(this, arguments);
        }
        if (J !== false) {
            this._correctSplit(E);
            this.resized = this._fake.resized = 1;
        }
        return J;
    };
    this._fake.changeCursorState = function (F) {
        var E = F.target || F.srcElement;
        if (E.tagName != "TD") {
            E = this.getFirstParentOfType(E, "TD");
        }
        if (E.tagName == "TD" && this._drsclmn && !this._drsclmn[E._cellIndex]) {
            return;
        }
        var D = (F.layerX || 0) +
            (!dhx4.isIE && F.target.tagName == "DIV" ? E.offsetLeft : 0);
        var H = parseInt(this.getPosition(E, this.hdrBox));
        if (E.offsetWidth - (F.offsetX || (H - D) * -1) < (dhx4.isOpera ? 20 : 10) ||
            this.entBox.offsetWidth -
                (F.offsetX ? F.offsetX + E.offsetLeft : D) +
                this.objBox.scrollLeft -
                0 <
                (dhx4.isOpera ? 20 : 10)) {
            E.style.cursor = "E-resize";
        }
        else {
            E.style.cursor = "default";
        }
        if (dhx4.isOpera) {
            this.hdrBox.scrollLeft = this.objBox.scrollLeft;
        }
    };
    this._fake.startColResizeA = this._fake.startColResize;
    this._fake.startColResize = function (E) {
        var F = this.startColResizeA(E);
        this._initalSplR = this.entBox.offsetWidth;
        this._initalSplF = null;
        if (this.entBox.onmousemove) {
            var D = this.entBox.parentNode;
            if (D._aggrid) {
                return F;
            }
            D._aggrid = D.grid;
            D.grid = this;
            this.entBox.parentNode.onmousemove = this.entBox.onmousemove;
            this.entBox.onmousemove = null;
        }
        return F;
    };
    this._fake.stopColResizeA = this._fake.stopColResize;
    this._fake.stopColResize = function (E) {
        if (this.entBox.parentNode.onmousemove) {
            var D = this.entBox.parentNode;
            D.grid = D._aggrid;
            D._aggrid = null;
            this.entBox.onmousemove = this.entBox.parentNode.onmousemove;
            this.entBox.parentNode.onmousemove = null;
            if (this.obj.offsetWidth < this.entBox.offsetWidth) {
                this._correctSplit(this.obj.offsetWidth);
            }
        }
        return this.stopColResizeA(E);
    };
    this.doKeyA = this.doKey;
    this._fake.doKeyA = this._fake.doKey;
    function l(K, J, D, M) {
        var E = M.shiftKey ? -1 : 1;
        var F = M.shiftKey ? -1 : D._cCount;
        var I = false;
        for (var H = K + E; H != F; H += E) {
            if (D.smartTabOrder) {
                I = D.cells2(J, H).isDisabled() ? false : H;
            }
            else {
                I = H;
            }
            if (I !== false) {
                var L = !D._key_events.k_other;
                D.selectCell(J, I, false, false, L, true);
                M.cancelBubble = true;
                if (M.preventDefault) {
                    M.preventDefault();
                }
                return true;
            }
        }
    }
    this._fake.doKey = this.doKey = function (I) {
        if (!I) {
            return true;
        }
        if (this._htkebl) {
            return true;
        }
        if ((I.target || I.srcElement).value !== window.undefined) {
            var E = I.target || I.srcElement;
            if (!E.parentNode || E.parentNode.className.indexOf("editable") == -1) {
                return true;
            }
        }
        switch (I.keyCode) {
            case 9:
                var H = this._realfake ? this._fake : this;
                if (!H.callEvent("onTab", [true])) {
                    return true;
                }
                if (this.cell) {
                    var F = this.cell._cellIndex;
                    var D = H.getRowIndex(this.cell.parentNode.idd);
                    while (!l(F, D, H, I)) {
                        D += I.shiftKey ? -1 : 1;
                        if (D < 0 || D >= H.rowsBuffer.length) {
                            return;
                        }
                        F = I.shiftKey ? H._cCount : -1;
                    }
                    return;
                }
                break;
        }
        return this.doKeyA(I);
    };
    this.editCellA = this.editCell;
    this.editCell = function () {
        if (this.cell && this.cell.parentNode.grid != this) {
            return this._fake.editCell();
        }
        return this.editCellA();
    };
    this.deleteRowA = this.deleteRow;
    this.deleteRow = function (D, E) {
        if (this.deleteRowA(D, E) === false) {
            return false;
        }
        if (this._fake.rowsAr[D]) {
            this._fake.deleteRow(D);
        }
    };
    this.clearAllA = this.clearAll;
    this.clearAll = function () {
        this.clearAllA();
        this._fake.clearAll();
    };
    this.editStopA = this.editStop;
    this.editStop = function (D) {
        if (this._fake.editor) {
            this._fake.editStop(D);
        }
        else {
            this.editStopA(D);
        }
    };
    this.attachEvent("onAfterSorting", function (E, D, F) {
        if (E >= m) {

            this._fake.setSortImgState(false);
        }
    });
    this._fake.sortField = function (E, D, H) {
        this._fake.sortField.call(this._fake, E, D, this._fake.hdr.rows[0].cells[E]);
        if (this.fldSort[E] != "na" && this._fake.fldSorted) {
            var F = this._fake.getSortingState()[1];
            this._fake.setSortImgState(false);
            this.setSortImgState(true, arguments[0], F);
        }
    };
    this.sortTreeRowsA = this.sortTreeRows;
    this._fake.sortTreeRowsA = this._fake.sortTreeRows;
    this.sortTreeRows = this._fake.sortTreeRows = function (F, H, D, E) {
        if (this._realfake) {
            return this._fake.sortTreeRows(F, H, D, E);
        }
        this.sortTreeRowsA(F, H, D, E);
        this._fake._h2syncModel();
        this._fake.setSortImgStateA(false);
        this._fake.fldSorted = null;
    };
    this._fake._fillers = [];
    this._fake.rowsBuffer = this.rowsBuffer;
    this.attachEvent("onClearAll", function () {

        this._fake.rowsBuffer = this.rowsBuffer;
    });
    this._add_filler_s = this._add_filler;
    this._add_filler = function (E, D, I, F) {
        if (!this._fake._fillers) {
            this._fake._fillers = [];
        }
        if (this._realfake || !F) {
            var H = null;
            if (I && I.idd) {
                H = this._fake.rowsAr[I.idd];
            }
            else {
                if (I && I.nextSibling) {
                    H = {};
                    H.nextSibling = this._fake.rowsAr[I.nextSibling.idd];
                    H.parentNode = H.nextSibling.parentNode;
                }
                else {
                    if (this._fake._fillers.length) {
                        H = this._fake._fillers[this._fake._fillers.length - 1][2];
                    }
                }
            }
            this._fake._fillers.push(this._fake._add_filler(E, D, H));
        }
        return this._add_filler_s.apply(this, arguments);
    };
    this._add_from_buffer_s = this._add_from_buffer;
    this._add_from_buffer = function () {
        var D = this._add_from_buffer_s.apply(this, arguments);
        if (D != -1) {
            this._fake._add_from_buffer.apply(this._fake, arguments);
            if (this.multiLine) {
                this._correctRowHeight(this.rowsBuffer[arguments[0]].idd);
            }
        }
        return D;
    };
    this._fake.render_row = function (D) {
        var E = this._fake.render_row(D);
        if (E == -1) {
            return -1;
        }
        if (E) {
            return (this.rowsAr[E.idd] =
                this.rowsAr[E.idd] || this._fake.copy_row(E));
        }
        return null;
    };
    this._reset_view_s = this._reset_view;
    this._reset_view = function () {
        this._fake._reset_view(true);
        this._fake._fillers = [];
        this._reset_view_s();
    };
    this.moveColumn_s = this.moveColumn;
    this.moveColumn = function (E, D) {
        if (D >= m) {
            return this.moveColumn_s(E, D);
        }
    };
    this.attachEvent("onCellChanged", function (I, F, H) {

        if (this._split_event && F < m && this.rowsAr[I]) {

            var D = this._fake.rowsAr[I];
            if (!D) {
                return;
            }
            if (D._childIndexes) {
                D = D.childNodes[D._childIndexes[F]];
            }
            else {
                D = D.childNodes[F];
            }

            var E = this.rowsAr[I].childNodes[F];
            if (E._treeCell && E.firstChild.lastChild) {
                E.firstChild.lastChild.innerHTML = H;
            }
            else {
                E.innerHTML = D.innerHTML;
            }
            E._clearCell = false;
            E.combo_value = D.combo_value;
            E.chstate = D.chstate;
        }
    });
    this._fake.combos = this.combos;
    this.setSizes();
    if (this.rowsBuffer[0]) {
        this._reset_view();
    }
    this.attachEvent("onXLE", function () {

        this._fake._correctSplit();
    });
    this._fake._correctSplit();
};
dhtmlXGridObject.prototype._correctSplit = function (c) {
    c = c || this.obj.scrollWidth - this.objBox.scrollLeft;
    c = Math.min(this.globalBox.offsetWidth, c);
    var g = null;
    if (c > -1) {
        this.entBox.style.width = c + "px";
        this.objBox.style.width = c + "px";
        g = (this.globalBox.offsetWidth - this.globalBox.clientWidth) / 2;
        this._fake.entBox.style.left = c + "px";
        this._fake.entBox.style.width =
            Math.max(0, this.globalBox.offsetWidth - c - (this.quirks ? 0 : 2) * g) +
                "px";
        if (this._fake.ftr) {
            this._fake.ftr.parentNode.style.width = this._fake.entBox.style.width;
        }
        if (dhx4.isIE) {
            var e = dhx4.isIE && !window.xmlHttpRequest;
            g = this.globalBox.offsetWidth - this.globalBox.clientWidth;
            this._fake.hdrBox.style.width = this._fake.objBox.style.width =
                Math.max(0, this.globalBox.offsetWidth - (e ? g : 0) - c) + "px";
        }
    }
};
dhtmlXGridObject.prototype._correctRowHeight = function (o, m) {
    if (!this.rowsAr[o] || !this._fake.rowsAr[o]) {
        return;
    }
    var l = parseInt(this.rowsAr[o].style.height) || this.rowsAr[o].offsetHeight;
    var e = parseInt(this._fake.rowsAr[o].style.height) ||
        this._fake.rowsAr[o].offsetHeight;
    var a = Math.max(l, e) - (this.rowsAr[o].delta_fix || 0);
    if (!a) {
        return;
    }
    this.rowsAr[o].style.height = this._fake.rowsAr[o].style.height =
        Math.round(a + 1) + "px";
    this.rowsAr[o].delta_fix = 1;
    if (window._KHTMLrv) {
        var c = this._fake._cCount;
        var n;
        while (!n && c >= 0) {
            n = this.rowsAr[o].childNodes[c];
            c -= 1;
        }
        var g = this._fake.rowsAr[o].firstChild;
        if (n && g) {
            n.style.height = g.style.height = a + "px";
        }
    }
};
/**
 * 启用自动保存到cookie的大小
 * @param name
 * @param cookie_param
 *
 * //minimal parameters set
 myGrid.enableAutoSizeSaving();
 //maximal parameters set
 myGrid.enableAutoSizeSaving("some_name","expires=Fri, 31-Dec-2010 23:59:59 GMT");
 */
dhtmlXGridObject.prototype.enableAutoSizeSaving = function (name, cookie_param) {
    this.attachEvent("onResizeEnd", function () {

        this.saveSizeToCookie(name, cookie_param);
    });
};
/**
 * 在cookie中存储Treegrid的打开状态
 * @param name
 * @param a
 */
dhtmlXGridObject.prototype.saveOpenStates = function (name, a) {
    if (!name) {
        name = this.entBox.id;
    }
    var e = [];
    this._h2.forEachChild(0, function (h) {
        if (h.state == "minus") {
            e.push(h.id);
        }
    });
    var g = "gridOpen" + (name || "") + "=" + e.join("|") + (a ? "; " + a : "");
    document.cookie = g;
};
dhtmlXGridObject.prototype.loadOpenStates = function (e, a) {
    var h = this.getCookie(e, "gridOpen");
    if (!h) {
        return;
    }
    h = h.split("|");
    for (var g = 0; g < h.length; g++) {
        var c = this.getParentId(h[g]);
        if (!this.getOpenState(c)) {
            continue;
        }
        this.openItem(h[g]);
    }
};
dhtmlXGridObject.prototype.enableAutoHiddenColumnsSaving = function (c, a) {
    this.attachEvent("onColumnHidden", function () {

        this.saveHiddenColumnsToCookie(c, a);
    });
};
/**
 * 允许自动将排序状态保存到cookie
 * @param name
 * @param cookie_param
 */
dhtmlXGridObject.prototype.enableSortingSaving = function (name, cookie_param) {
    this.attachEvent("onBeforeSorting", function () {

        var e = this;
        window.setTimeout(function () {
            e.saveSortingToCookie(name, cookie_param);
        }, 1);
        return true;
    });
};
dhtmlXGridObject.prototype.enableOrderSaving = function (c, a) {
    this.attachEvent("onAfterCMove", function () {

        this.saveOrderToCookie(c, a);

        this.saveSizeToCookie(c, a);
    });
};
dhtmlXGridObject.prototype.enableAutoSaving = function (c, a) {
    this.enableOrderSaving(c, a);
    this.enableAutoSizeSaving(c, a);
    this.enableSortingSaving(c, a);
};
dhtmlXGridObject.prototype.saveSizeToCookie = function (c, a) {
    var h = null;
    if (this.cellWidthType == "px") {
        h = this.cellWidthPX;
    }
    else {
        h = this.cellWidthPC;
    }
    var g = (this.initCellWidth || []).join(",");
    if (this._hrrar) {
        for (var e = 0; e < this._hrrar.length; e++) {
            if (this._hrrar[e]) {
                h[e] = "";
            }
        }
    }
    this.setCookie(c, a, 0, h.join(","));
    this.setCookie(c, a, 1, g);
};
dhtmlXGridObject.prototype.saveHiddenColumnsToCookie = function (c, a) {
    var g = [].concat(this._hrrar || []);
    if (this._fake && this._fake._hrrar) {
        for (var e = 0; e < this._fake._cCount; e++) {
            g[e] = this._fake._hrrar[e] ? "1" : "";
        }
    }
    this.setCookie(c, a, 4, g.join(",").replace(/display:none;/g, "1"));
};
dhtmlXGridObject.prototype.loadHiddenColumnsFromCookie = function (c) {
    var g = this._getCookie(c, 4);
    var a = (g || "").split(",");
    for (var e = 0; e < this._cCount; e++) {
        this.setColumnHidden(e, a[e] ? true : false);
    }
};
dhtmlXGridObject.prototype.saveSortingToCookie = function (c, a) {
    this.setCookie(c, a, 2, (this.getSortingState() || []).join(","));
};
dhtmlXGridObject.prototype.loadSortingFromCookie = function (a) {
    var c = this._getCookie(a, 2);
    c = (c || "").split(",");
    if (c.length > 1 && c[0] < this._cCount) {
        this.sortRows(c[0], null, c[1]);
        this.setSortImgState(true, c[0], c[1]);
    }
};
dhtmlXGridObject.prototype.saveOrderToCookie = function (e, a) {
    if (!this._c_order) {
        this._c_order = [];
        var c = this._cCount;
        for (var g = 0; g < c; g++) {
            this._c_order[g] = g;
        }
    }
    this.setCookie(e, a, 3, (this._c_order || []).slice(0, this._cCount).join(","));
    this.saveSortingToCookie(e, a);
};
dhtmlXGridObject.prototype.loadOrderFromCookie = function (c) {
    var h = this._getCookie(c, 3);
    h = (h || "").split(",");
    if (h.length > 1 && h.length <= this._cCount) {
        for (var g = 0; g < h.length; g++) {
            if ((!this._c_order && h[g] != g) ||
                (this._c_order && h[g] != this._c_order[g])) {
                var e = h[g];
                if (this._c_order) {
                    for (var a = 0; a < this._c_order.length; a++) {
                        if (this._c_order[a] == h[g]) {
                            e = a;
                            break;
                        }
                    }
                }
                this.moveColumn(e * 1, g);
            }
        }
    }
};
dhtmlXGridObject.prototype.loadSizeFromCookie = function (a) {
    var e = this._getCookie(a, 1);
    if (e) {
        this.initCellWidth = e.split(",");
    }
    e = this._getCookie(a, 0);
    if (e && e.length) {
        e = e.split(",");
        if (!this._fake && this._hrrar) {
            for (var c = 0; c < e.length; c++) {
                if (this._hrrar[c]) {
                    e[c] = 0;
                }
            }
        }
        if (this.cellWidthType == "px") {
            this.cellWidthPX = e;
        }
        else {
            this.cellWidthPC = e;
        }
    }
    for (var c_1 = 0; c_1 < e.length; c_1++) {
        if (e[c_1] === "") {
            e[c_1] = this.initCellWidth[c_1];
            this.setColumnHidden(c_1, true);
        }
    }
    this.setSizes();
    return true;
};
dhtmlXGridObject.prototype.clearConfigCookie = function (a) {
    if (!a) {
        a = this.entBox.id;
    }
    var c = "gridSettings" + a + "=||||";
    document.cookie = c;
};
dhtmlXGridObject.prototype.clearSizeCookie = dhtmlXGridObject.prototype.clearConfigCookie;
dhtmlXGridObject.prototype.setCookie = function (c, a, l, g) {
    if (!c) {
        c = this.entBox.id;
    }
    var e = this.getCookie(c);
    e = (e || "||||").split("|");
    e[l] = g;
    var h = "gridSettings" +
        c +
        "=" +
        e.join("|").replace(/,/g, "-") +
        (a ? "; " + a : "");
    document.cookie = h;
};
dhtmlXGridObject.prototype.getCookie = function (c, g) {
    if (!c) {
        c = this.entBox.id;
    }
    c = (g || "gridSettings") + c;
    var e = c + "=";
    if (document.cookie.length > 0) {
        var h = document.cookie.indexOf(e);
        if (h != -1) {
            h += e.length;
            var a = document.cookie.indexOf(";", h);
            if (a == -1) {
                a = document.cookie.length;
            }
            return document.cookie.substring(h, a);
        }
    }
};
dhtmlXGridObject.prototype._getCookie = function (a, c) {
    return (this.getCookie(a) || "||||").replace(/-/g, ",").split("|")[c];
};
/**
 * 在网格中启用撤消/重做功能
 */
dhtmlXGridObject.prototype.enableUndoRedo = function () {
    var c = this;
    var e = function () {
        return c._onEditUndoRedo.apply(c, arguments);
    };
    this.attachEvent("onEditCell", e);
    var a = function (h, g, l) {
        return c._onEditUndoRedo.apply(c, [2, h, g, l ? 1 : 0, l ? 0 : 1]);
    };
    this.attachEvent("onCheckbox", a);
    this._IsUndoRedoEnabled = true;
    this._UndoRedoData = [];
    this._UndoRedoPos = -1;
};
/**
 * 禁用网格中的撤消/重做功能
 */
dhtmlXGridObject.prototype.disableUndoRedo = function () {
    this._IsUndoRedoEnabled = false;
    this._UndoRedoData = [];
    this._UndoRedoPos = -1;
};
dhtmlXGridObject.prototype._onEditUndoRedo = function (e, c, l, g, a) {
    if (this._IsUndoRedoEnabled && e == 2 && a != g) {
        if (this._UndoRedoPos !== -1 &&
            this._UndoRedoPos != this._UndoRedoData.length - 1) {
            this._UndoRedoData = this._UndoRedoData.slice(0, this._UndoRedoPos + 1);
        }
        else {
            if (this._UndoRedoPos === -1 && this._UndoRedoData.length > 0) {
                this._UndoRedoData = [];
            }
        }
        var h = { old_value: a, new_value: g, row_id: c, cell_index: l };
        this._UndoRedoData.push(h);
        this._UndoRedoPos++;
    }
    return true;
};
/**
 * 执行撤消操作
 */
dhtmlXGridObject.prototype.doUndo = function () {
    if (this._UndoRedoPos === -1) {
        return false;
    }
    var a = this._UndoRedoData[this._UndoRedoPos--];
    var e = this.cells(a.row_id, a.cell_index);
    if (this.getColType(a.cell_index) == "tree") {
        e.setLabel(a.old_value);
    }
    else {
        e.setValue(a.old_value);
    }
    this.callEvent("onUndo", [a.row_id]);
};
/**
 * 执行重做操作
 */
dhtmlXGridObject.prototype.doRedo = function () {
    if (this._UndoRedoPos == this._UndoRedoData.length - 1) {
        return false;
    }
    var a = this._UndoRedoData[++this._UndoRedoPos];
    this.cells(a.row_id, a.cell_index).setValue(a.new_value);
    this.callEvent("onUndo", [a.row_id]);
};
/**
 * 获取可用重做操作的长度
 */
dhtmlXGridObject.prototype.getRedo = function () {
    if (this._UndoRedoPos == this._UndoRedoData.length - 1) {
        return [];
    }
    return this._UndoRedoData.slice(this._UndoRedoPos + 1);
};
/**
 * 获取撤消操作的长度
 */
dhtmlXGridObject.prototype.getUndo = function () {
    if (this._UndoRedoPos == -1) {
        return [];
    }
    return this._UndoRedoData.slice(0, this._UndoRedoPos + 1);
};
/**
 * 启用访问键盘导航
 */
dhtmlXGridObject.prototype.enableAccessKeyMap = function () {
    this._select_ifpossible = function () {
        if (this.editor && this.editor.obj && this.editor.obj.select) {
            this.editor.obj.select();
        }
    };
    this._key_events = {
        k13_1_0: function () {
            this.editStop();
        },
        k13_0_1: function () {
            this._key_events.k9_0_1.call(this);
        },
        k13_0_0: function () {
            this._key_events.k9_0_0.call(this);
        },
        k9_0_0: function () {
            this.editStop();
            if (!this.callEvent("onTab", [true])) {
                return true;
            }
            var a = this._getNextCell(null, 1);
            if (a) {
                if (this.pagingOn) {
                    this.showRow(a.parentNode.idd);
                }
                this.selectCell(a.parentNode, a._cellIndex, this.row != a.parentNode, false, true);
                this._still_active = true;
            }
            this._select_ifpossible();
        },
        k9_0_1: function () {
            this.editStop();
            if (!this.callEvent("onTab", [false])) {
                return true;
            }
            var a = this._getNextCell(null, -1);
            if (a) {
                this.selectCell(a.parentNode, a._cellIndex, this.row != a.parentNode, false, true);
                this._still_active = true;
            }
            this._select_ifpossible();
        },
        k113_0_0: function () {
            if (this._f2kE) {
                this.editCell();
            }
        },
        k32_0_0: function () {
            var a = this.cells4(this.cell);
            if (!a.changeState || a.changeState() === false) {
                return false;
            }
        },
        k27_0_0: function () {
            this.editStop(true);
        },
        k33_0_0: function () {
            if (this.pagingOn) {
                this.changePage(this.currentPage - 1);
            }
            else {
                this.scrollPage(-1);
            }
        },
        k34_0_0: function () {
            if (this.pagingOn) {
                this.changePage(this.currentPage + 1);
            }
            else {
                this.scrollPage(1);
            }
        },
        k37_0_0: function () {
            if (this.editor) {
                return false;
            }
            if (this.isTreeGrid()) {
                this.collapseKids(this.row);
            }
            else {
                this._key_events.k9_0_1.call(this);
            }
        },
        k39_0_0: function () {
            if (this.editor) {
                return false;
            }
            if (!this.editor && this.isTreeGrid()) {
                this.expandKids(this.row);
            }
            else {
                this._key_events.k9_0_0.call(this);
            }
        },
        k37_1_0: function () {
            if (this.editor) {
                return false;
            }
            this.selectCell(this.row, 0, false, false, true);
            this._select_ifpossible();
        },
        k39_1_0: function () {
            if (this.editor) {
                return false;
            }
            this.selectCell(this.row, this._cCount - 1, false, false, true);
            this._select_ifpossible();
        },
        k38_1_0: function () {
            this.selectCell(this.rowsCol[0], this.cell._cellIndex, true, false, true);
            this._select_ifpossible();
        },
        k40_1_0: function () {
            this.selectCell(this.rowsCol[this.rowsCol.length - 1], this.cell._cellIndex, true, false, true);
            this._select_ifpossible();
        },
        k38_0_1: function () {
            var a = this.getRowIndex(this.row.idd);
            var c = this._nextRow(a, -1);
            if (!c || c._sRow || c._rLoad) {
                return false;
            }
            this.selectCell(c, this.cell._cellIndex, true, false, true);
            this._select_ifpossible();
        },
        k40_0_1: function () {
            var a = this.getRowIndex(this.row.idd);
            var c = this._nextRow(a, 1);
            if (!c || c._sRow || c._rLoad) {
                return false;
            }
            this.selectCell(c, this.cell._cellIndex, true, false, true);
            this._select_ifpossible();
        },
        k38_1_1: function () {
            var a = this.getRowIndex(this.row.idd);
            for (var c = a; c >= 0; c--) {
                this.selectCell(this.rowsCol[c], this.cell._cellIndex, true, false, true);
            }
        },
        k40_1_1: function () {
            var a = this.getRowIndex(this.row.idd);
            for (var c = a + 1; c < this.rowsCol.length; c++) {
                this.selectCell(this.rowsCol[c], this.cell._cellIndex, true, false, true);
            }
        },
        k40_0_0: function () {
            if (this.editor && this.editor.combo) {
                this.editor.shiftNext();
            }
            else {
                if (!this.row.idd) {
                    return;
                }
                var a = (a = this.getRowIndex(this.row.idd) + 1);
                if (this.rowsBuffer[a]) {
                    var c = this._nextRow(a - 1, 1);
                    if (this.pagingOn && c) {
                        this.showRow(c.idd);
                    }
                    this._Opera_stop = 0;
                    this.selectCell(c, this.cell._cellIndex, true, false, true);
                }
                else {
                    if (!this.callEvent("onLastRow", [])) {
                        return false;
                    }
                    this._key_events.k34_0_0.apply(this, []);
                }
            }
            this._still_active = true;
        },
        k36_0_0: function () {
            return this._key_events.k37_1_0.call(this);
        },
        k35_0_0: function () {
            return this._key_events.k39_1_0.call(this);
        },
        k36_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[0], 0, true, false, true);
            this._select_ifpossible();
        },
        k35_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[this.rowsCol.length - 1], this._cCount - 1, true, false, true);
            this._select_ifpossible();
        },
        k38_0_0: function () {
            if (this.editor && this.editor.combo) {
                this.editor.shiftPrev();
            }
            else {
                if (!this.row.idd) {
                    return;
                }
                var a = (a = this.getRowIndex(this.row.idd) + 1);
                if (a != -1) {
                    var c = this._nextRow(a - 1, -1);
                    this._Opera_stop = 0;
                    if (this.pagingOn && c) {
                        this.showRow(c.idd);
                    }
                    this.selectCell(c, this.cell._cellIndex, true, false, true);
                }
                else {
                    this._key_events.k33_0_0.apply(this, []);
                }
            }
            this._still_active = true;
        }
    };
};
/**
 * 启用Excel键盘导航
 */
dhtmlXGridObject.prototype.enableExcelKeyMap = function () {
    this._key_events = {
        k13_1_0: function () {
            this.editStop();
        },
        k13_0_1: function () {
            this.editStop();
            this._key_events.k38_0_0.call(this);
        },
        k13_0_0: function () {
            this.editStop();
            this.callEvent("onEnter", [
                this.row ? this.row.idd : null,
                this.cell ? this.cell._cellIndex : null
            ]);
            this._still_active = true;
            this._key_events.k40_0_0.call(this);
        },
        k9_0_0: function () {
            this.editStop();
            if (!this.callEvent("onTab", [true])) {
                return true;
            }
            if (this.cell && this.cell._cellIndex + 1 >= this._cCount) {
                return;
            }
            var a = this._getNextCell(null, 1);
            if (a && this.row == a.parentNode) {
                this.selectCell(a.parentNode, a._cellIndex, true);
                this._still_active = true;
            }
        },
        k9_0_1: function () {
            this.editStop();
            if (!this.callEvent("onTab", [false])) {
                return true;
            }
            if (this.cell && this.cell._cellIndex == 0) {
                return;
            }
            var a = this._getNextCell(null, -1);
            if (a && this.row == a.parentNode) {
                this.selectCell(a.parentNode, a._cellIndex, true);
                this._still_active = true;
            }
        },
        k113_0_0: function () {
            if (this._f2kE) {
                this.editCell();
            }
        },
        k32_0_0: function () {
            var a = this.cells4(this.cell);
            if (!a.changeState || a.changeState() === false) {
                return false;
            }
        },
        k27_0_0: function () {
            this.editStop(true);
            this._still_active = true;
        },
        k33_0_0: function () {
            if (this.pagingOn) {
                this.changePage(this.currentPage - 1);
            }
            else {
                this.scrollPage(-1);
            }
        },
        k34_0_0: function () {
            if (this.pagingOn) {
                this.changePage(this.currentPage + 1);
            }
            else {
                this.scrollPage(1);
            }
        },
        k37_0_0: function () {
            if (this.editor) {
                return false;
            }
            if (this.isTreeGrid()) {
                this.collapseKids(this.row);
            }
            else {
                this._key_events.k9_0_1.call(this);
            }
        },
        k39_0_0: function () {
            if (this.editor) {
                return false;
            }
            if (!this.editor && this.isTreeGrid()) {
                this.expandKids(this.row);
            }
            else {
                this._key_events.k9_0_0.call(this);
            }
        },
        k37_1_0: function () {
            if (this.editor) {
                return false;
            }
            this.selectCell(this.row, 0, true);
        },
        k39_1_0: function () {
            if (this.editor) {
                return false;
            }
            this.selectCell(this.row, this._cCount - 1, true);
        },
        k38_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[0], this.cell._cellIndex, true);
        },
        k40_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[this.rowsCol.length - 1], this.cell._cellIndex, true);
        },
        k38_0_1: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            var a = this.row.rowIndex;
            var c = this._nextRow(a - 1, -1);
            if (!c || c._sRow || c._rLoad) {
                return false;
            }
            this.selectCell(c, this.cell._cellIndex, true, true);
        },
        k40_0_1: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            var a = this.row.rowIndex;
            var c = this._nextRow(a - 1, 1);
            if (!c || c._sRow || c._rLoad) {
                return false;
            }
            this.selectCell(c, this.cell._cellIndex, true, true);
        },
        k38_1_1: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            var a = this.row.rowIndex;
            for (var c = a - 1; c >= 0; c--) {
                this.selectCell(this.rowsCol[c], this.cell._cellIndex, true, true);
            }
        },
        k40_1_1: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            var a = this.row.rowIndex;
            for (var c = a; c < this.rowsCol.length; c++) {
                this.selectCell(this.rowsCol[c], this.cell._cellIndex, true, true);
            }
        },
        k40_0_0: function () {
            var c = this._realfake ? this._fake : this;
            if (this.editor && this.editor.combo) {
                this.editor.shiftNext();
            }
            else {
                if (this.editor) {
                    return false;
                }
                var a = Math.max(c._r_select || 0, this.getRowIndex(this.row.idd));
                var e = this._nextRow(a, 1);
                if (e) {
                    c._r_select = null;
                    this.selectCell(e, this.cell._cellIndex, true);
                    if (c.pagingOn) {
                        c.showRow(e.idd);
                    }
                }
                else {
                    if (!this.callEvent("onLastRow", [])) {
                        return false;
                    }
                    this._key_events.k34_0_0.apply(this, []);
                }
            }
        },
        k36_0_0: function () {
            return this._key_events.k37_1_0.call(this);
        },
        k35_0_0: function () {
            return this._key_events.k39_1_0.call(this);
        },
        k36_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[0], 0, true);
        },
        k35_1_0: function () {
            if (this.editor || !this.rowsCol.length) {
                return false;
            }
            this.selectCell(this.rowsCol[this.rowsCol.length - 1], this._cCount - 1, true);
        },
        k38_0_0: function () {
            var c = this._realfake ? this._fake : this;
            if (this.editor && this.editor.combo) {
                this.editor.shiftPrev();
            }
            else {
                if (this.editor) {
                    return false;
                }
                if (!this.row.idd) {
                    return;
                }
                var a = this.getRowIndex(this.row.idd) + 1;
                if (a != -1 && (!this.pagingOn || a != 1)) {
                    var e = this._nextRow(a - 1, -1);
                    this.selectCell(e, this.cell._cellIndex, true);
                    if (c.pagingOn && e) {
                        c.showRow(e.idd);
                    }
                }
                else {
                    this._key_events.k33_0_0.apply(this, []);
                }
            }
        },
        k_other: function (e) {
            if (this.editor) {
                return false;
            }
            if (!e.ctrlKey &&
                e.keyCode >= 40 &&
                (e.keyCode < 91 ||
                    (e.keyCode > 95 && e.keyCode < 111) ||
                    e.keyCode > 187)) {
                if (this.cell) {
                    var g = this.cells4(this.cell);
                    if (g.isDisabled()) {
                        return false;
                    }
                    var a = g.getValue();
                    if (g.editable !== false) {
                        g.setValue("");
                    }
                    this.editCell();
                    if (this.editor) {
                        this.editor.val = a;
                        if (this.editor.obj && this.editor.obj.select) {
                            this.editor.obj.select();
                        }
                    }
                    else {
                        g.setValue(a);
                    }
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods2.js